import React from "react";

import { Grid, Link, Typography, useTheme } from "@mui/material";

import moment from "moment";
import { globalVariables } from "../../global/GlobalVariables";
import SocialsGroup from "./SocialsGroup";
import { useTranslation } from "react-i18next";
import { getLanguageCookie } from "../../language/LanguageFunctions";

import { getEnvironmentVariable } from "../../global/environmentVariables";
const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

const getPartnersArray = () => {
  let partnersArray = [];
  if (
    getEnvironmentVariable("PARTNERS_ARRAY") !== undefined &&
    getEnvironmentVariable("PARTNERS_ARRAY") !== "NOT SET"
  ) {
    try {
      partnersArray = JSON.parse(getEnvironmentVariable("PARTNERS_ARRAY"));
    } catch (err) {}
  }
  return partnersArray;
};

export default function Footer(props) {
  const { paddingLeft } = props;
  const globalVars = globalVariables();
  const partnersArray = getPartnersArray();
  const theme = useTheme();
  const language = getLanguageCookie();
  const { t } = useTranslation("translation", {
    lng: language,
    keyPrefix: "components.Footer"
  });

  const HAS_LARGE_BANNER_LOGO =
    getEnvironmentVariable("HAS_LARGE_BANNER_LOGO") === "true";

  return (
    <Grid
      container
      component="footer"
      sx={{
        backgroundColor: "banner.main",
        color: "banner.contrastText",
        padding: 2,
        maxWidth: "unset !important",
        width: "100%",
        paddingLeft: paddingLeft || [null, null, null, "256px"],
        p: 1,
      }}
    >
      <Grid
        item
        xs={12}
        md={partnersArray?.length > 0 ? 4 : 6}
        sx={{
          fontSize: "30px",
          textAlign: "center",
          p: 1,
        }}
      >
        <img
          src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/BannerLogo${
            theme.palette.mode === "dark" ? "Dark" : ""
          }${HAS_LARGE_BANNER_LOGO ? "Large" : ""}.png`}
          alt="logo"
          style={{
            maxHeight: "70px",
          }}
        />
        <SocialsGroup title={t("connectWithUs")} />
      </Grid>

      <Grid
        item
        xs={12}
        md={partnersArray?.length > 0 ? 4 : 6}
        sx={{
          textAlign: "right",
          display: "flex",
          flexDirection: "column",
          justifyContent: "unset",
          alignItems: "center",
          p: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: "700", fontSize: "20px" }}
        >
          {t("quickLinks")}
        </Typography>
        <Link color="inherit" underline="none" href="/">
          {t("home")}
        </Link>

        <Link color="inherit" underline="none" href="/play/events">
          {t("events")}
        </Link>

        {!NO_SUBSCRIPTIONS && (
          <Link color="inherit" underline="none" href="/subscription">
            {t("subscription")}
          </Link>
        )}

        <Link color="inherit" underline="none" href="/store-finder">
          {t("storeFinder")}
        </Link>

        <Link color="inherit" underline="none" href="/pricing">
          {t("ticketing")}
        </Link>
      </Grid>

      {partnersArray?.length > 0 && (
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            textAlign: "right",
            display: "flex",
            flexDirection: "column",
            justifyContent: "unset",
            alignItems: "center",
            p: 1,
          }}
        >
          <>
            <Typography
              variant="body1"
              sx={{ fontWeight: "700", fontSize: "20px" }}
            >
              {t("partners")}
            </Typography>
            {getPartnersArray().map((partner, index) => {
              return (
                <Link
                  color="inherit"
                  underline="none"
                  href={partner.href}
                  target={partner.target}
                  key={index}
                >
                  {partner.title}
                </Link>
              );
            })}
          </>
        </Grid>
      )}

      <Grid item xs={12} sx={{ p: 1, pt: 4 }}>
        {globalVars?.footer?.disclaimer &&
        !globalVars?.footer?.disclaimer?.split("\n").length ? (
          <Typography variant="body2" color="inherit" align="center">
            {globalVars.footer.disclaimer}
          </Typography>
        ) : globalVars?.footer?.disclaimer &&
          globalVars?.footer?.disclaimer?.split("\n").length ? (
          <>
            {globalVars?.footer?.disclaimer.split("\n").map((text, key) => (
              <Typography
                variant="body2"
                color="inherit"
                align="center"
                key={key}
              >
                {text}
              </Typography>
            ))}
          </>
        ) : (
          <Typography variant="body2" color="inherit" align="center">
            Copyright © {moment().format("yyyy")}{" "}
            {getEnvironmentVariable("COMPANY_NAME")}{" "}
            {t("copyrightAllRightsReserved")}
          </Typography>
        )}
        <Typography variant="body2" color="inherit" align="center">
          <Link
            href="/privacy"
            target="_blank"
            color="inherit"
            underline="none"
          >
            {t("privacyPolicy")}
          </Link>{" "}
          |{" "}
          <Link href="/eula" target="_blank" color="inherit" underline="none">
            {t("termsOfServiceEula")}
          </Link>{" "}
          |{" "}
          <Link
            href="/data-collection"
            target="_blank"
            color="inherit"
            underline="none"
          >
            {t("dataCollection")}
          </Link>
        </Typography>
        {IS_DEV && (
          <Typography variant="body2" color="error" align="center">
            This is a development site
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}
